import { css } from 'styled-components';
import { theme } from '../theme';
export const focusOutline = ({ selector = '&:focus-visible', } = {}) => css `
  outline: 0;

  ${selector} {
    outline: 2px solid ${theme.colors.liquorice};
    outline-offset: 2px;
  }
`;
export const focusOutlineStyle = css `
  &:focus-visible {
    outline: 2px solid ${theme.colors.liquorice};
    outline-offset: 2px;
  }
`;
//# sourceMappingURL=focusOutline.js.map